import React, { useEffect, useRef } from 'react';
import './Projects.css';

const Projects = () => {
  const projectRefs = useRef([]);

  const addToRefs = (el) => {
    if (el && !projectRefs.current.includes(el)) {
      projectRefs.current.push(el);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.2 } // Trigger when 20% of the item is visible
    );

    const currentRefs = projectRefs.current;

    currentRefs.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      currentRefs.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  return (
    <section className="projects-section">
      <div className="projects-container">

        {/* Header Section */}
        <div className="projects-header">
          <img
            src='https://res.cloudinary.com/dexueorjm/image/upload/v1776843809/backcover_projects_flg4x6.png'
            className='project-hero-image'
            alt="Project Overview"
          />
          <div>
            <span className="section-subtitle">Our Expertise</span>
            <h2 className="section-title">Farming Methods</h2>
          </div>
        </div>

        {/* Commercial Farming */}
        <div className="farming-card" ref={addToRefs}>
          <div className="farming-visual">
            <img
              src="https://res.cloudinary.com/dexueorjm/image/upload/v1772688744/DSC00910_pskf7v.jpg"
              alt="Commercial Farming"
            />
          </div>
          <div className="farming-content">
            <h3>Commercial Farming</h3>
            <p>
              Large-scale agriculture driven by profit and advanced technology, primarily producing crops and livestock for the global market.
            </p>
            <ul className='farming-feature-list'>
              <li><strong>Intensive farming:</strong> High-input techniques for maximum yield.</li>
              <li><strong>Mechanization:</strong> Advanced machinery for efficiency.</li>
              <li><strong>Monoculture:</strong> Specialized focus on high-demand crops.</li>
              <li><strong>Use of chemicals:</strong> Fertilizers, pesticides, and herbicides are common.</li>
              <li><strong>Irrigation systems:</strong> Large-scale irrigation is often employed.</li>
            </ul>
          </div>
        </div>

        {/* Corporate Farming */}
        <div className="farming-card" ref={addToRefs}>
          <div className="farming-visual">
            <img
              src="https://res.cloudinary.com/dexueorjm/image/upload/v1772688737/PHOTO-2026-03-02-09-50-14_2_fkuot0.jpg"
              alt="Corporate Farming"
            />
          </div>
          <div className="farming-content">
            <h3>Corporate Farming</h3>
            <p>
              Agribusiness on a massive scale, owned and operated by major corporations to ensure streamlined mass production.
            </p>
            <ul className='farming-feature-list'>
              <li><strong>Ownership:</strong> Managed by multinational entities.</li>
              <li><strong>Vertical integration:</strong> Full control over the supply chain.</li>
              <li><strong>Economies of scale:</strong> Optimized for lower per-unit costs.</li>
              <li><strong>Genetic modification:</strong> Use of genetically modified crops and R&D.</li>
              <li><strong>Global markets:</strong> Aimed at export markets or large retail chains.</li>
            </ul>
          </div>
        </div>

        {/* Natural Farming */}
        <div className="farming-card" ref={addToRefs}>
          <div className="farming-visual">
            <img
              src="https://res.cloudinary.com/dexueorjm/image/upload/v1772688734/PHOTO-2026-03-02-09-54-49_xfzxpe.jpg"
              alt="Natural Farming"
            />
          </div>
          <div className="farming-content">
            <h3>Natural Farming</h3>
            <p>
              A sustainable approach that respects nature's cycles, avoiding synthetic chemicals to promote ecological balance.
            </p>
            <ul className="farming-feature-list">
              <li><strong>No chemicals:</strong> No fertilizers or pesticides used.</li>
              <li><strong>Biodiversity:</strong> Rich mix of crops and livestock.</li>
              <li><strong>No-till farming:</strong> Reducing soil disturbance.</li>
              <li><strong>Composting and green manure:</strong> Natural methods for soil health.</li>
              <li><strong>Water conservation:</strong> Sustainable water use.</li>
            </ul>
          </div>
        </div>

        {/* Traditional Farming */}
        <div className="farming-card" ref={addToRefs}>
          <div className="farming-visual">
            <img
              src="https://res.cloudinary.com/dexueorjm/image/upload/v1772688732/PHOTO-2026-03-02-09-55-15_jyrhg1.jpg"
              alt="Traditional Farming"
            />
          </div>
          <div className="farming-content">
            <h3>Traditional Farming</h3>
            <p>
              Time-honored practices passed down through generations, often family-run and deeply rooted in local ecosystems.
            </p>
            <ul className="farming-feature-list">
              <li><strong>Scale:</strong> Small-scale, community-focused farms.</li>
              <li><strong>Crop diversity:</strong> Resilience promotes food security.</li>
              <li><strong>Mixed farming:</strong> Harmonious integration of crops and animals.</li>
              <li><strong>Sustainable methods:</strong> Natural pest control and crop rotation.</li>
              <li><strong>Local markets:</strong> Products are sold locally or consumed by the family.</li>
            </ul>
          </div>
        </div>

        <div className="projects-header" style={{ marginBottom: 0, marginTop: '40px' }}>
          <p className="section-subtitle" style={{ fontSize: '1rem', letterSpacing: '2px' }}>Emerging Farmers Empowerment</p>
        </div>

      </div>
    </section>
  );
};

export default Projects;
